import { http } from "./http";
import type { components } from "./schema";

export type PriceList = components["schemas"]["PriceList"];

// DTO для создания/обновления (мягкие типы, чтобы не зависеть от swagger-типов dto)
export type PriceListCreateDto = {
  title: string;
  description: string;
  price?: string;
  direction_key?: string; // ✅ новое поле
};

export type PriceListUpdateDto = Partial<PriceListCreateDto>;

export async function getPriceList(): Promise<PriceList[]> {
  const { data } = await http.get<PriceList[]>("/price-list");
  return data;
}

// ✅ новый метод: прайс по направлению
export async function getPriceListByDirection(directionKey: string): Promise<PriceList[]> {
  const { data } = await http.get<PriceList[]>("/price-list", {
    params: { directionKey },
  });
  return data;
}

// ✅ CRUD (для админки)
export async function createPriceList(dto: PriceListCreateDto): Promise<PriceList> {
  const { data } = await http.post<PriceList>("/price-list", dto);
  return data;
}

export async function updatePriceList(id: number, dto: PriceListUpdateDto): Promise<PriceList> {
  const { data } = await http.patch<PriceList>(`/price-list/${id}`, dto);
  return data;
}

export async function deletePriceList(id: number): Promise<void> {
  await http.delete(`/price-list/${id}`);
}